<template>
<div class="box-labourParticulars">
    <div class="nav">
        <img src="../../assets/up.png" alt="" class="upClass" @click="getOnPage1">
        会议预订
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active" id="active-boxId">会议配套周边预订流程</h4>
                    <p>1. 预订前提 </p>
                    <span class="spanClass labourParticulars-title-content-active">因公需赴外地参加会议时，需通过学校，统一在携程商旅中预订机票；由于火车票没有优惠，各部门自行购买报销即可（标准参照附录四）。因公邀请外地老师来津时可通过学校预订酒店，享受协议价格。</span>
                    <p>2. 因公会议机票的申请 </p>
                    <span class="spanClass labourParticulars-title-content-active">将申请邮件（正文需包括会议相关邮件、姓名、身份证号码、会议需要往返时间等信息）依次发送至部门总监、校长审批，如多人一同前往，则由带队人员发送邮件申请。
                        将审批完成的邮件转发至校办总监刘胜洪（liushenghong）知悉，同时抄送校办代博（daibo3）</span>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active" id="active-boxId">会议配套周边预订流程</h4>
                    <span class="spanClass labourParticulars-title-content-active">高帆（gaofan14），在不影响参会的情况下，本着节省费用的原则进行沟通及购票，收到回复邮件即完成购票。</span>
                    <p>3. 因公预订酒店的申请</p>
                    <span class="spanClass labourParticulars-title-content-active">发送申请邮件至部门总监审批，邮件需说明来访人目的、姓名、意向酒店、入住及离店日期、房型，以及如何支付费用等信息。</span>
                    <span class="spanClass labourParticulars-title-content-active">将部门总监审批后的邮件转发至校办总监刘胜洪（liushenghong）悉知，并抄送校办代博（daibo3）、高帆（gaofan14）进行预订，收到回复邮件即完成预定。</span>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow: false,
            flowShow: false,
            agreementShow: false
        };
    },
    methods: {
        getOnPage1(){
            var name = this.$route.params.name
            if(name == 'ff'){
                this.$router.push({name: "IssueManpower3"})
            }else {
                this.$router.push({name: "Administrative"})
            }
        },
        fn() {

        },
        getOnPage() {
            this.$router.push({name: 'Search', params:{code:"1112"}})
        },
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical" // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 30%;
    display: block;
    margin: 10px auto;
}
.labourParticulars-title-active {
    font-size: 16px
}
.labourParticulars-title-content-active {
    letter-spacing:2px;
    line-height: 30px;
}
#active-boxId {
    margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Administrative/administrative4.vue